<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        Novo Cadastro
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card style="width: 500px; margin: auto;">

    <form [formGroup]="memberForm">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.name"
           autocomplete="off">
        <mat-error *ngIf="memberForm.controls.name.hasError('required')">
          O nome é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome no crachá</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.shortName"
           autocomplete="off">
        <mat-error *ngIf="memberForm.controls.shortName.hasError('required')">
          O nome crachá é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.email"
           autocomplete="off">
        <mat-error *ngIf="memberForm.controls.email.hasError('required')">
          O email é obrigatório
        </mat-error>
      </mat-form-field>

      <div style="display: flex; flex-direction: row; justify-content: space-between;">

        <mat-form-field class="field-width" appearance="outline">
          <mat-label>Celular</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cellPhone"
             autocomplete="off">
          <mat-error *ngIf="memberForm.controls.cellPhone.hasError('required')">
            O celular é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="field-width" appearance="outline">
          <mat-label>Documento</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cpf"
             autocomplete="off">
          <mat-error *ngIf="memberForm.controls.cpf.hasError('required')">
            O CPF é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="field-width" appearance="outline">
          <mat-label>CRM</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.crm"
             autocomplete="off">
          <mat-error *ngIf="memberForm.controls.crm.hasError('required')">
            O CRM é obrigatório
          </mat-error>
        </mat-form-field>

      </div>

    </form>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Selecione uma categoria</mat-label>
      <mat-select (ngModelChange)='subCategorySelectedChange($event)' [formControl]="memberForm.controls.subCategory_id">
        <mat-option *ngFor="let subCat of subCategories" [value]="subCat.id">
          {{ subCat.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="subCategorySelected.documents" style="width: 100%; text-align: justify; padding:5px 10px 20px 5px; color: blue; ">
      Apresentar {{subCategorySelected.documents}} 
    </div>

    <div style="display:flex; flex-direction: row; justify-content: space-between;">

      <div style="height: 40px; width: 100%;">
        <button mat-raised-button class="button-ok" (click)='registerMember()' [disabled]="memberForm.invalid" >
          Cadastrar
        </button>
      </div>

    </div>

  </mat-card>

</div>